import React, { useState, useRef } from "react";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import { useForm } from "react-hook-form";
import Tooltip from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import { ToastContainer, toast } from "react-toastify";

import AddContractSettingService from "../../services/settings/AddContractSettingService";
import { getTrans as t } from "../../Localization/translations"
import AddInvoiceSettingService from "../../services/settings/AddInvoiceSettingService";
import ButtonLoading from "../../components/Loder/buttonLoading";

function Setting() {
  const checkBtn = useRef();
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [disable_automatic, setDisable_Automatic] = useState("");
  const [prefix, setPrefix] = useState("");
  const [number, setNumber] = useState("");
  const [suffixnumber, setSuffixNumber] = useState("");
  const [invoiceseries, setInvoiceSeries] = useState("");
  const [loading, setLoading] = useState(false)
  const [invoiceloading, setInvoiceLoading] = useState(false)
  const form = useRef();

  const handleContract = () => {
    setLoading(true)
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      let contract_number_method = { disable_automatic } ? "Automatic" : "Manual"
      if (contract_number_method = disable_automatic === "Automatic") {
        contract_number_method = "Automatic"
      } else {
        contract_number_method = "Manual"
      }
      AddContractSettingService.addContractSetting(
        contract_number_method,
        prefix,
        number,
        suffixnumber
      ).then(
        (response) => {
          if (response.data.success) {
            setLoading(false)
            window.location.reload()
            toast.success(`${response.data.response}`,{
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",})
          }
          else {
            toast.error(`${response.data.error}`,{
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",})
            setLoading(false)

          }
        },
      )
    }
  }

  const handleInvoice = () => {
    setInvoiceLoading(true)
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      AddInvoiceSettingService.addInvoiceSetting(
        invoiceseries
      ).then(
        (response) => {
          if (response.data.success) {
            setInvoiceLoading(false)
            toast.success(`${response.data.response}`,{
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",})
          }
          else {
            toast.error(`${response.data.error}`,{
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",})
              setInvoiceLoading(false)
          }
        },
      )
    }
  }

  return (
    <>
      <div className="">
        <div className="header pb-0">
        <ToastContainer />
          <div className="d-lg-flex">
            <div>
              <h5 className="mb-3 tc">{t("Contract Settings")}</h5>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="">
        <div className="">
          <div className="card">
            <div className="row">
              <div className="col-md-12">
                <div className="card-body">
                  <Form role="form text-left"
                    onSubmit={handleSubmit(handleContract)}
                    ref={form}
                    action="."
                    method="POST"
                    id="addReceiptForm" >
                    {(
                      <>
                        <div className="d-lg-flex">
                          <div>
                            <h5 className="mb-0 form-label py-3 tc">{t("Contract Number")} <Tooltip content={t("ContractNumber_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></h5>
                          </div>
                        </div>
                        <div className=" row">
                          <div className="col-md-6">
                            <div className="row">
                              <div className="col-lg-1 text-right">
                                <input
                                  checked={disable_automatic === 'Automatic' ? true : false}
                                  onChange={(e) => setDisable_Automatic(e.target.value)}
                                  type="checkbox" value="Automatic" name="automatic" id="automatic" />
                              </div>
                              <div className="col-lg-6">
                                <label className="col-lg-6 ">{t("Automatic")}
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="row">
                              <div className="col-lg-1">
                                <input
                                  checked={disable_automatic === 'Manual' ? true : false}
                                  onChange={(e) => setDisable_Automatic(e.target.value)}
                                  type="checkbox" value="Manual" name="manual" id="overide_application" />
                              </div>
                              <div className="col-lg-6">
                                <label className="col-lg-6 ">{t("Manual")}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="form-group row">
                          <div className="col-lg-6">
                            <label className=" col-form-label">{t("Prefix")} <Tooltip content={t("Prefix_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                            <div className="col-lg-12">
                              <input
                                placeholder={t('Ex. ABC')}
                                className="form-control"
                                type="text"
                                disabled={disable_automatic === 'Automatic' ? false : true}
                                onChange={(e) => setPrefix(e.target.value)}
                                name="Prefix"
                                id="Prefix"
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <label className=" col-form-label">{t("Number")} <Tooltip content={t("Number_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                            <div className="col-lg-12">
                              <input
                                placeholder={t('Ex. 10000')}
                                className="form-control"
                                type="number"
                                disabled={disable_automatic === 'Automatic' ? false : true}
                                {...register("number", { onChange: (e) => { setNumber(e.target.value) }, valueAsNumber: true, required: disable_automatic === 'Automatic' ? true : false })}
                              />
                              <div className="invalid-feedback">
                                {errors.number?.type === 'required' && "Number  is required"}
                              </div>
                            </div>
                          </div>
                        </div>
                        <label className="col-lg-12 col-form-label">{t("Suffix Number")} <Tooltip content={t("Suffixnumber_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                        <div className="col-lg-6">
                          <input
                            placeholder={t('Ex. XYZ')}
                            className="form-control"
                            type="text"
                            disabled={disable_automatic === 'Automatic' ? false : true}
                            onChange={(e) => setSuffixNumber(e.target.value)}
                            name="suffixnumber"
                            id="suffixnumber"
                          />
                        </div>
                        <div className="text-left py-3 pt-4">
                          <button type="submit" className="btn-save border-0 btn btn-primary btn-gradient-primary btn-md">
                            {
                              loading === false ? (

                                t('Save')
                              ) : (
                                <ButtonLoading />
                              )
                            }
                          </button>&nbsp;&nbsp;
                        </div>
                      </>
                    )}
                    <CheckButton style={{ display: "none" }} ref={checkBtn} />
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="">
        <div className="">
          <div>
            <b>
              <h5 className="mt-3 mb-3 tc">{t("Invoice Setting")}</h5>
            </b>
          </div>
        </div>
        <div className="card">
          <div className="row">
            <div className="col-md-12">
              <div className="card-body">
                <Form role="form text-left"
                  onSubmit={handleSubmit(handleInvoice)}
                  ref={form}
                  action="."
                  method="POST"
                  id="addReceiptForm" >
                  {(
                    <>
                      <div className="form-group row">
                        <div className="col-md-6">
                        </div>
                      </div>
                      <label className="col-lg-12 col-form-label required">{t("Starting Series of Invoice")} <Tooltip content={t("StartingSeriesofInvoice_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                      <div className="col-lg-6">
                        <input
                          placeholder={t('Ex. 10000')}
                          className="form-control"
                          type="number"
                          onChange={(e) => setInvoiceSeries(e.target.value)}
                          name="startingseriesofcontract"
                          id="startingseriesofcontract"
                        />
                      </div>
                      <div className="text-left py-3">
                        <button type="submit" className="btn-save border-0 btn btn-primary btn-gradient-primary btn-md">
                          {
                            invoiceloading === false ? (
                              t('Save')
                            ) : (
                              <ButtonLoading />
                            )
                          }
                        </button>&nbsp;&nbsp;
                      </div>
                    </>
                  )}
                  <CheckButton style={{ display: "none" }} ref={checkBtn} />
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Setting
